
(function() {
  // Your spam list: phrases or single words, case-insensitive, whole word or phrase
  const SPAM_PATTERNS = [
    "seo",
    "backlink",
    "promote",
    "promotion",
    "crypto",
    "bitcoin",
    "forex",
    "loan",
    "traffic",
    "guest post",
    "casino",
    "porn",
    "escort",
    "mailing list",
    "marketing services",
    "learning purposes",
    "shoul"
  ];
  
  // Build a single regex that matches any of the above as whole words/phrases
  // \b for words; for phrases we allow spaces as-is.
  const escaped = SPAM_PATTERNS.map(s =>
    s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  );
  const spamRegex = new RegExp("\\b(" + escaped.join("|") + ")\\b", "i");

  function attachGuards(root = document) {
    // Select Shopify contact forms reliably:
    //  - Must contain hidden input: name="form_type" value="contact"
    //  - Action contains "/contact" (covers /contact, /contact#contact_form)
    const forms = Array.from(root.querySelectorAll('form[action*="/contact"]'))
      .filter(f => f.querySelector('input[name="form_type"][value="contact"]'));

    forms.forEach(form => {
      // Avoid double-binding
      if (form.__antiSpamBound) return;
      form.__antiSpamBound = true;

      form.addEventListener("submit", function(e) {
        // 1) Honeypot
        const honeypot = form.querySelector('input[name="website"]');
        if (honeypot && honeypot.value.trim() !== "") {
          e.preventDefault();
          e.stopImmediatePropagation();
          // Optionally show a silent fail or a friendly message
          alert("Your message could not be sent. Please remove suspicious content and try again.");
          return false;
        }

        // 2) Keyword/phrase check (search entire message body)
        // Common Shopify contact body field names
        const messageField =
          form.querySelector('textarea[name="contact[body]"]') ||
          form.querySelector('textarea[name="contact[message]"]') ||
          form.querySelector('textarea[name*="contact"]') ||
          form.querySelector('textarea');

        const subjectField =
          form.querySelector('input[name="contact[subject]"]') ||
          form.querySelector('input[name="subject"]');

        let text = "";
        if (messageField) text += " " + (messageField.value || "");
        if (subjectField) text += " " + (subjectField.value || "");
        text = text.toLowerCase();

        if (text && spamRegex.test(text)) {
          e.preventDefault();
          e.stopImmediatePropagation();
          alert("Your message could not be delivered as it contains restricted terms.");
          return false;
        }

        // 3) Optional: rate-limit same user quickly resubmitting (basic)
        // const last = sessionStorage.getItem("lastContactSubmit");
        // const now = Date.now();
        // if (last && (now - (+last)) < 15000) { // 15s
        //   e.preventDefault();
        //   alert("Please wait a moment before submitting again.");
        //   return false;
        // }
        // sessionStorage.setItem("lastContactSubmit", String(now));
      }, true); // use capture to intercept before other handlers (incl. reCAPTCHA)
    });
  }

  // Initial bind
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => attachGuards());
  } else {
    attachGuards();
  }

  // Re-bind when Shopify dynamically loads sections (customizers, some themes)
  document.addEventListener("shopify:section:load", (ev) => {
    attachGuards(ev.target || document);
  });
  document.addEventListener("shopify:section:select", (ev) => {
    attachGuards(ev.target || document);
  });
})();
